export class Discount {
    id: string;
    name: string;
    amount: number;
    percentage: number;
 }
